/* global axios */
import ApiClient from './ApiClient';

class TalkviaQuotesAPI extends ApiClient {
  constructor() {
    super('talkvia_quotes', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, { talkvia_quote: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { talkvia_quote: payload });
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  schedule(id, startsAt) {
    return axios.post(`${this.url}/${id}/schedule`, { starts_at: startsAt });
  }
}

export default new TalkviaQuotesAPI();
